export default __webpack_public_path__ + "static/media/lms.2af4bc9d.svg";